<template>
  <article class="article-item">
      <div class="ribbon" v-bind:class="{ 'cr-orange': article.acf.status=='Postponed', 'cr-blue': article.acf.status=='Rescheduled', 'cr-black': article.acf.status=='Cancelled' }" v-if="article.acf.status && article.acf.status!='None'">
        {{ article.acf.status }}
      </div>
      <div class="row px-3">
        <div class="col-3 pt-2">
          <div class="event-date ">
            {{displayEventDate(article)}}
          </div>
        </div>
         <div class="col-9">
          <h5>{{ article.acf.title }}</h5>
          <p v-if="article.acf.description" v-html="article.acf.description"></p>
          <a v-if="article.acf.show_post_link" :href="article.link" class="click-next">Learn more</a>
          <a v-else-if="article.acf.link.title" :href="article.acf.link.url" :target="article.acf.link.target" class="click-next">{{article.acf.link.title}}</a>
         </div>
      </div>
  </article>
</template>

<script>
import moment from "moment";

export default {
  props: {
    article: {
      type: Object,
      required: true
    }
  },
  methods: {
    displayEventDate: function (article) {
      const startDate = article.acf.event_start_date;
      const endDate = article.acf.event_end_date;
      let dateStr = 'No date';
      if (startDate == endDate) {
        dateStr = moment(endDate).format('MMM DD');
      } else {
        dateStr = moment(startDate).format('MMM DD') + ' - ' + moment(endDate).format('MMM DD');
      }
      return dateStr;
    }
  },
  filters: {
    formatDate: function (value) {
      if (!value) return '';
      return moment(value).format('MMM DD');
    }
  }
};
</script>

<style lang="scss" scoped>
.article-item {
  padding: 40px 10px;
  margin: 20px 0;
  background: #F5F5F4;
  text-align: left;
  position: relative;
  overflow: hidden;
  a{
    color: #2a7996;
  }
  .event-date{
    border: 1px solid #424242;
    padding: 10px;
    font-weight: 500;
  }
  h5{
    font-weight: 400;
  }
  p{
    font-size: 16px;
  }
  &__content {
    display: flex;
  }

}
.ribbon {
  margin: 0;
  padding: 0;
  color:white;
  padding:10px 0;
  text-align: center;
  position: absolute;
  top:30px;
  left:4px;
  transform: translateX(0%) translateY(120%) rotate(-45deg);
  transform-origin: top left;
  z-index: 8;
  min-width: 100px;
  font-size: 14px;
  font-weight: 500;
  &:before,
  &:after {
    content: '';
    position: absolute;
    top:0;
    margin: 0 -1px; /* tweak */
    width: 100%;
    height: 100%;
  }
  &:before {
    right:100%;
  }

  &:after {
    left:100%;
  }
  &.cr-blue,&.cr-blue:before,&.cr-blue:after{ background-color: #1976d2; }
  &.cr-black,&.cr-black:before,&.cr-black:after{ background-color: #424242; }
  &.cr-orange,&.cr-orange:before,&.cr-orange:after{ background-color: #ff8f00; color: #000; }
}

</style>